var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// ../../node_modules/traverse/index.js
var require_traverse = __commonJS({
  "../../node_modules/traverse/index.js"(exports, module) {
    "use strict";
    function toS(obj) {
      return Object.prototype.toString.call(obj);
    }
    function isDate(obj) {
      return toS(obj) === "[object Date]";
    }
    function isRegExp(obj) {
      return toS(obj) === "[object RegExp]";
    }
    function isError(obj) {
      return toS(obj) === "[object Error]";
    }
    function isBoolean(obj) {
      return toS(obj) === "[object Boolean]";
    }
    function isNumber(obj) {
      return toS(obj) === "[object Number]";
    }
    function isString(obj) {
      return toS(obj) === "[object String]";
    }
    var isArray = Array.isArray || function isArray2(xs) {
      return Object.prototype.toString.call(xs) === "[object Array]";
    };
    function forEach(xs, fn) {
      if (xs.forEach) {
        return xs.forEach(fn);
      }
      for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
      }
      return void 0;
    }
    var objectKeys = Object.keys || function keys(obj) {
      var res = [];
      for (var key in obj) {
        res.push(key);
      }
      return res;
    };
    var hasOwnProperty = Object.prototype.hasOwnProperty || function(obj, key) {
      return key in obj;
    };
    function copy(src) {
      if (typeof src === "object" && src !== null) {
        var dst;
        if (isArray(src)) {
          dst = [];
        } else if (isDate(src)) {
          dst = new Date(src.getTime ? src.getTime() : src);
        } else if (isRegExp(src)) {
          dst = new RegExp(src);
        } else if (isError(src)) {
          dst = { message: src.message };
        } else if (isBoolean(src) || isNumber(src) || isString(src)) {
          dst = Object(src);
        } else if (Object.create && Object.getPrototypeOf) {
          dst = Object.create(Object.getPrototypeOf(src));
        } else if (src.constructor === Object) {
          dst = {};
        } else {
          var proto = src.constructor && src.constructor.prototype || src.__proto__ || {};
          var T = function T2() {
          };
          T.prototype = proto;
          dst = new T();
        }
        forEach(objectKeys(src), function(key) {
          dst[key] = src[key];
        });
        return dst;
      }
      return src;
    }
    function walk(root, cb, immutable) {
      var path = [];
      var parents = [];
      var alive = true;
      return function walker(node_) {
        var node = immutable ? copy(node_) : node_;
        var modifiers = {};
        var keepGoing = true;
        var state = {
          node,
          node_,
          path: [].concat(path),
          parent: parents[parents.length - 1],
          parents,
          key: path[path.length - 1],
          isRoot: path.length === 0,
          level: path.length,
          circular: null,
          update: function(x, stopHere) {
            if (!state.isRoot) {
              state.parent.node[state.key] = x;
            }
            state.node = x;
            if (stopHere) {
              keepGoing = false;
            }
          },
          delete: function(stopHere) {
            delete state.parent.node[state.key];
            if (stopHere) {
              keepGoing = false;
            }
          },
          remove: function(stopHere) {
            if (isArray(state.parent.node)) {
              state.parent.node.splice(state.key, 1);
            } else {
              delete state.parent.node[state.key];
            }
            if (stopHere) {
              keepGoing = false;
            }
          },
          keys: null,
          before: function(f) {
            modifiers.before = f;
          },
          after: function(f) {
            modifiers.after = f;
          },
          pre: function(f) {
            modifiers.pre = f;
          },
          post: function(f) {
            modifiers.post = f;
          },
          stop: function() {
            alive = false;
          },
          block: function() {
            keepGoing = false;
          }
        };
        if (!alive) {
          return state;
        }
        function updateState() {
          if (typeof state.node === "object" && state.node !== null) {
            if (!state.keys || state.node_ !== state.node) {
              state.keys = objectKeys(state.node);
            }
            state.isLeaf = state.keys.length === 0;
            for (var i = 0; i < parents.length; i++) {
              if (parents[i].node_ === node_) {
                state.circular = parents[i];
                break;
              }
            }
          } else {
            state.isLeaf = true;
            state.keys = null;
          }
          state.notLeaf = !state.isLeaf;
          state.notRoot = !state.isRoot;
        }
        updateState();
        var ret = cb.call(state, state.node);
        if (ret !== void 0 && state.update) {
          state.update(ret);
        }
        if (modifiers.before) {
          modifiers.before.call(state, state.node);
        }
        if (!keepGoing) {
          return state;
        }
        if (typeof state.node === "object" && state.node !== null && !state.circular) {
          parents.push(state);
          updateState();
          forEach(state.keys, function(key, i) {
            path.push(key);
            if (modifiers.pre) {
              modifiers.pre.call(state, state.node[key], key);
            }
            var child = walker(state.node[key]);
            if (immutable && hasOwnProperty.call(state.node, key)) {
              state.node[key] = child.node;
            }
            child.isLast = i === state.keys.length - 1;
            child.isFirst = i === 0;
            if (modifiers.post) {
              modifiers.post.call(state, child);
            }
            path.pop();
          });
          parents.pop();
        }
        if (modifiers.after) {
          modifiers.after.call(state, state.node);
        }
        return state;
      }(root).node;
    }
    function Traverse(obj) {
      this.value = obj;
    }
    Traverse.prototype.get = function(ps) {
      var node = this.value;
      for (var i = 0; i < ps.length; i++) {
        var key = ps[i];
        if (!node || !hasOwnProperty.call(node, key)) {
          return void 0;
        }
        node = node[key];
      }
      return node;
    };
    Traverse.prototype.has = function(ps) {
      var node = this.value;
      for (var i = 0; i < ps.length; i++) {
        var key = ps[i];
        if (!node || !hasOwnProperty.call(node, key)) {
          return false;
        }
        node = node[key];
      }
      return true;
    };
    Traverse.prototype.set = function(ps, value) {
      var node = this.value;
      for (var i = 0; i < ps.length - 1; i++) {
        var key = ps[i];
        if (!hasOwnProperty.call(node, key)) {
          node[key] = {};
        }
        node = node[key];
      }
      node[ps[i]] = value;
      return value;
    };
    Traverse.prototype.map = function(cb) {
      return walk(this.value, cb, true);
    };
    Traverse.prototype.forEach = function(cb) {
      this.value = walk(this.value, cb, false);
      return this.value;
    };
    Traverse.prototype.reduce = function(cb, init) {
      var skip = arguments.length === 1;
      var acc = skip ? this.value : init;
      this.forEach(function(x) {
        if (!this.isRoot || !skip) {
          acc = cb.call(this, acc, x);
        }
      });
      return acc;
    };
    Traverse.prototype.paths = function() {
      var acc = [];
      this.forEach(function() {
        acc.push(this.path);
      });
      return acc;
    };
    Traverse.prototype.nodes = function() {
      var acc = [];
      this.forEach(function() {
        acc.push(this.node);
      });
      return acc;
    };
    Traverse.prototype.clone = function() {
      var parents = [];
      var nodes = [];
      return function clone(src) {
        for (var i = 0; i < parents.length; i++) {
          if (parents[i] === src) {
            return nodes[i];
          }
        }
        if (typeof src === "object" && src !== null) {
          var dst = copy(src);
          parents.push(src);
          nodes.push(dst);
          forEach(objectKeys(src), function(key) {
            dst[key] = clone(src[key]);
          });
          parents.pop();
          nodes.pop();
          return dst;
        }
        return src;
      }(this.value);
    };
    function traverse2(obj) {
      return new Traverse(obj);
    }
    forEach(objectKeys(Traverse.prototype), function(key) {
      traverse2[key] = function(obj) {
        var args = [].slice.call(arguments, 1);
        var t = new Traverse(obj);
        return t[key].apply(t, args);
      };
    });
    module.exports = traverse2;
  }
});

// ../../node_modules/next-axiom/dist/shared.js
var require_shared = __commonJS({
  "../../node_modules/next-axiom/dist/shared.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.throttle = exports.EndpointType = exports.isNoPrettyPrint = void 0;
    exports.isNoPrettyPrint = process.env.AXIOM_NO_PRETTY_PRINT == "true" ? true : false;
    var EndpointType;
    (function(EndpointType2) {
      EndpointType2["webVitals"] = "web-vitals";
      EndpointType2["logs"] = "logs";
    })(EndpointType = exports.EndpointType || (exports.EndpointType = {}));
    var throttle = function(fn, wait) {
      var lastFn, lastTime;
      return function() {
        var context = this, args = arguments;
        if (lastTime == null) {
          lastTime = Date.now();
        }
        clearTimeout(lastFn);
        lastFn = setTimeout(function() {
          if (Date.now() - lastTime >= wait) {
            fn.apply(context, args);
            lastTime = Date.now();
          }
        }, Math.max(wait - (Date.now() - lastTime), 0));
      };
    };
    exports.throttle = throttle;
  }
});

// ../../node_modules/next-axiom/dist/platform/generic.js
var require_generic = __commonJS({
  "../../node_modules/next-axiom/dist/platform/generic.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var shared_1 = require_shared();
    var GenericConfig = function() {
      function GenericConfig2() {
        this.proxyPath = "/_axiom";
        this.isBrowser = typeof window !== "undefined";
        this.shoudSendEdgeReport = false;
        this.token = process.env.AXIOM_TOKEN;
        this.dataset = process.env.AXIOM_DATASET;
        this.environment = process.env.NODE_ENV;
        this.axiomUrl = process.env.AXIOM_URL || "https://cloud.axiom.co";
        this.region = process.env.REGION || void 0;
      }
      GenericConfig2.prototype.isEnvVarsSet = function() {
        return !!(this.axiomUrl && process.env.AXIOM_DATASET && process.env.AXIOM_TOKEN);
      };
      GenericConfig2.prototype.getIngestURL = function(_) {
        return "".concat(this.axiomUrl, "/api/v1/datasets/").concat(this.dataset, "/ingest");
      };
      GenericConfig2.prototype.getLogsEndpoint = function() {
        return this.isBrowser ? "".concat(this.proxyPath, "/logs") : this.getIngestURL(shared_1.EndpointType.logs);
      };
      GenericConfig2.prototype.getWebVitalsEndpoint = function() {
        return this.isBrowser ? "".concat(this.proxyPath, "/logs") : this.getIngestURL(shared_1.EndpointType.webVitals);
      };
      GenericConfig2.prototype.wrapWebVitalsObject = function(metrics) {
        var _this = this;
        return metrics.map(function(m) {
          return {
            webVital: m,
            _time: new Date().getTime(),
            platform: {
              environment: _this.environment,
              source: "web-vital"
            }
          };
        });
      };
      GenericConfig2.prototype.injectPlatformMetadata = function(logEvent, source) {
        logEvent.platform = {
          environment: this.environment,
          region: this.region,
          source: source + "-log"
        };
      };
      GenericConfig2.prototype.generateRequestMeta = function(req) {
        return {
          startTime: new Date().getTime(),
          path: req.url,
          method: req.method,
          host: this.getHeaderOrDefault(req, "host", ""),
          userAgent: this.getHeaderOrDefault(req, "user-agent", ""),
          scheme: "https",
          ip: this.getHeaderOrDefault(req, "x-forwarded-for", ""),
          region: this.region
        };
      };
      GenericConfig2.prototype.getHeaderOrDefault = function(req, headerName, defaultValue) {
        return req.headers[headerName] ? req.headers[headerName] : defaultValue;
      };
      return GenericConfig2;
    }();
    exports.default = GenericConfig;
  }
});

// ../../node_modules/next-axiom/dist/platform/vercel.js
var require_vercel = __commonJS({
  "../../node_modules/next-axiom/dist/platform/vercel.js"(exports) {
    "use strict";
    var __extends = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (Object.prototype.hasOwnProperty.call(b2, p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var generic_1 = __importDefault(require_generic());
    var ingestEndpoint = process.env.NEXT_PUBLIC_AXIOM_INGEST_ENDPOINT || process.env.AXIOM_INGEST_ENDPOINT || "";
    var VercelConfig = function(_super) {
      __extends(VercelConfig2, _super);
      function VercelConfig2() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.provider = "vercel";
        _this.shoudSendEdgeReport = true;
        _this.region = process.env.VERCEL_REGION || void 0;
        _this.environment = process.env.VERCEL_ENV || process.env.NODE_ENV;
        _this.token = void 0;
        _this.axiomUrl = ingestEndpoint;
        return _this;
      }
      VercelConfig2.prototype.isEnvVarsSet = function() {
        return ingestEndpoint != void 0 && ingestEndpoint != "";
      };
      VercelConfig2.prototype.getIngestURL = function(t) {
        var url = new URL(this.axiomUrl);
        url.searchParams.set("type", t.toString());
        return url.toString();
      };
      VercelConfig2.prototype.getWebVitalsEndpoint = function() {
        return "".concat(this.proxyPath, "/web-vitals");
      };
      VercelConfig2.prototype.wrapWebVitalsObject = function(metrics) {
        return {
          webVitals: metrics,
          environment: this.environment
        };
      };
      VercelConfig2.prototype.injectPlatformMetadata = function(logEvent, source) {
        logEvent.vercel = {
          environment: this.environment,
          region: this.region,
          source
        };
      };
      return VercelConfig2;
    }(generic_1.default);
    exports.default = VercelConfig;
  }
});

// ../../node_modules/next-axiom/dist/platform/netlify.js
var require_netlify = __commonJS({
  "../../node_modules/next-axiom/dist/platform/netlify.js"(exports) {
    "use strict";
    var __extends = exports && exports.__extends || function() {
      var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
          d2.__proto__ = b2;
        } || function(d2, b2) {
          for (var p in b2)
            if (Object.prototype.hasOwnProperty.call(b2, p))
              d2[p] = b2[p];
        };
        return extendStatics(d, b);
      };
      return function(d, b) {
        if (typeof b !== "function" && b !== null)
          throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
          this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
      };
    }();
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    var generic_1 = __importDefault(require_generic());
    var netlifySiteId = process.env.SITE_ID;
    var netlifyBuildId = process.env.BUILD_ID;
    var netlifyContext = process.env.CONTEXT;
    var netlifyDeploymentUrl = process.env.DEPLOYMENT_URL;
    var netlifyDeploymentId = process.env.DEPLOYMENT_ID;
    var NetlifyConfig = function(_super) {
      __extends(NetlifyConfig2, _super);
      function NetlifyConfig2() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      NetlifyConfig2.prototype.wrapWebVitalsObject = function(metrics) {
        var _this = this;
        return metrics.map(function(m) {
          return {
            webVital: m,
            _time: new Date().getTime(),
            netlify: {
              environment: _this.environment,
              source: "web-vital",
              siteId: netlifySiteId,
              buildId: netlifyBuildId,
              context: netlifyContext,
              deploymentUrl: netlifyDeploymentUrl,
              deploymentId: netlifyDeploymentId
            }
          };
        });
      };
      NetlifyConfig2.prototype.injectPlatformMetadata = function(logEvent, source) {
        logEvent.netlify = {
          environment: this.environment,
          region: source === "edge" ? process.env.DENO_REGION : process.env.AWS_REGION,
          source: source + "-log",
          siteId: netlifySiteId,
          buildId: netlifyBuildId,
          context: netlifyContext,
          deploymentUrl: netlifyDeploymentUrl,
          deploymentId: source === "edge" ? process.env.DENO_DEPLOYMENT_ID : netlifyDeploymentId
        };
      };
      return NetlifyConfig2;
    }(generic_1.default);
    exports.default = NetlifyConfig;
  }
});

// ../../node_modules/next-axiom/package.json
var require_package = __commonJS({
  "../../node_modules/next-axiom/package.json"(exports, module) {
    module.exports = {
      name: "next-axiom",
      description: "Send WebVitals from your Next.js project to Axiom.",
      version: "0.18.0",
      author: "Axiom, Inc.",
      license: "MIT",
      contributors: [
        "Arne Bahlo <arne@axiom.co>",
        "Islam Shehata <islam@axiom.co>"
      ],
      engines: {
        node: ">=15"
      },
      main: "dist/index.js",
      types: "dist/index.d.ts",
      scripts: {
        build: "tsc",
        prepare: "npm run build",
        format: "prettier --write src/*.ts __tests__/*.ts",
        "check-format": "prettier -c src/*.ts __tests__/*.ts",
        test: "jest"
      },
      repository: {
        type: "git",
        url: "git+https://github.com/axiomhq/next-axiom.git"
      },
      keywords: [
        "web-vitals",
        "axiom",
        "observability",
        "performance",
        "nextjs"
      ],
      bugs: {
        url: "https://github.com/axiomhq/next-axiom/issues"
      },
      homepage: "https://github.com/axiomhq/next-axiom#readme",
      peerDependencies: {
        next: "^12.1.4 || ^13"
      },
      devDependencies: {
        "@types/jest": "^27.5.1",
        "@types/node": "^17.0.29",
        jest: "^28.1.0",
        "jest-environment-jsdom": "^28.1.0",
        prettier: "2.6.2",
        "ts-jest": "^28.0.2",
        "ts-node": "^10.8.0",
        typescript: "^4.6.4"
      },
      dependencies: {
        "whatwg-fetch": "^3.6.2"
      }
    };
  }
});

// ../../node_modules/next-axiom/dist/config.js
var require_config = __commonJS({
  "../../node_modules/next-axiom/dist/config.js"(exports) {
    "use strict";
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.isNetlify = exports.isVercel = exports.Version = void 0;
    var generic_1 = __importDefault(require_generic());
    var vercel_1 = __importDefault(require_vercel());
    var netlify_1 = __importDefault(require_netlify());
    exports.Version = require_package().version;
    exports.isVercel = process.env.AXIOM_INGEST_ENDPOINT || process.env.NEXT_PUBLIC_AXIOM_INGEST_ENDPOINT;
    exports.isNetlify = process.env.NETLIFY == "true";
    var config = new generic_1.default();
    if (exports.isVercel) {
      config = new vercel_1.default();
    } else if (exports.isNetlify) {
      config = new netlify_1.default();
    }
    exports.default = config;
  }
});

// ../../node_modules/next-axiom/dist/webVitals.js
var require_webVitals = __commonJS({
  "../../node_modules/next-axiom/dist/webVitals.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.reportWebVitalsWithPath = exports.reportWebVitals = void 0;
    var shared_1 = require_shared();
    var config_1 = __importStar(require_config());
    var url = config_1.default.getWebVitalsEndpoint();
    var throttledSendMetrics = (0, shared_1.throttle)(sendMetrics, 1e3);
    var collectedMetrics = [];
    function reportWebVitals(metric) {
      reportWebVitalsWithPath(metric);
    }
    exports.reportWebVitals = reportWebVitals;
    function reportWebVitalsWithPath(metric, path) {
      var _a;
      var route = path || ((_a = window.__NEXT_DATA__) === null || _a === void 0 ? void 0 : _a.page);
      collectedMetrics.push(__assign({ route }, metric));
      if (!config_1.default.isEnvVarsSet()) {
        return;
      }
      throttledSendMetrics();
    }
    exports.reportWebVitalsWithPath = reportWebVitalsWithPath;
    function sendMetrics() {
      var body = JSON.stringify(config_1.default.wrapWebVitalsObject(collectedMetrics));
      var headers = {
        "Content-Type": "application/json",
        "User-Agent": "next-axiom/v" + config_1.Version
      };
      if (config_1.default.token) {
        headers["Authorization"] = "Bearer ".concat(config_1.default.token);
      }
      var reqOptions = { body, method: "POST", keepalive: true, headers };
      function sendFallback() {
        fetch(url, reqOptions).catch(console.error);
      }
      if (config_1.default.isBrowser && config_1.isVercel && navigator.sendBeacon) {
        try {
          navigator.sendBeacon.bind(navigator)(url, body);
        } catch (err) {
          sendFallback();
        }
      } else {
        sendFallback();
      }
      collectedMetrics = [];
    }
  }
});

// ../../node_modules/whatwg-fetch/fetch.js
var fetch_exports = {};
__export(fetch_exports, {
  DOMException: () => DOMException,
  Headers: () => Headers,
  Request: () => Request,
  Response: () => Response,
  fetch: () => fetch2
});
function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj);
}
function normalizeName(name) {
  if (typeof name !== "string") {
    name = String(name);
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === "") {
    throw new TypeError('Invalid character in header field name: "' + name + '"');
  }
  return name.toLowerCase();
}
function normalizeValue(value) {
  if (typeof value !== "string") {
    value = String(value);
  }
  return value;
}
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift();
      return { done: value === void 0, value };
    }
  };
  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator;
    };
  }
  return iterator;
}
function Headers(headers) {
  this.map = {};
  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value);
    }, this);
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1]);
    }, this);
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name]);
    }, this);
  }
}
function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError("Already read"));
  }
  body.bodyUsed = true;
}
function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result);
    };
    reader.onerror = function() {
      reject(reader.error);
    };
  });
}
function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsArrayBuffer(blob);
  return promise;
}
function readBlobAsText(blob) {
  var reader = new FileReader();
  var promise = fileReaderReady(reader);
  reader.readAsText(blob);
  return promise;
}
function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf);
  var chars = new Array(view.length);
  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i]);
  }
  return chars.join("");
}
function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0);
  } else {
    var view = new Uint8Array(buf.byteLength);
    view.set(new Uint8Array(buf));
    return view.buffer;
  }
}
function Body() {
  this.bodyUsed = false;
  this._initBody = function(body) {
    this.bodyUsed = this.bodyUsed;
    this._bodyInit = body;
    if (!body) {
      this._bodyText = "";
    } else if (typeof body === "string") {
      this._bodyText = body;
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body;
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body;
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString();
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer);
      this._bodyInit = new Blob([this._bodyArrayBuffer]);
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body);
    } else {
      this._bodyText = body = Object.prototype.toString.call(body);
    }
    if (!this.headers.get("content-type")) {
      if (typeof body === "string") {
        this.headers.set("content-type", "text/plain;charset=UTF-8");
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set("content-type", this._bodyBlob.type);
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
      }
    }
  };
  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected;
      }
      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]));
      } else if (this._bodyFormData) {
        throw new Error("could not read FormData body as blob");
      } else {
        return Promise.resolve(new Blob([this._bodyText]));
      }
    };
    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this);
        if (isConsumed) {
          return isConsumed;
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          );
        } else {
          return Promise.resolve(this._bodyArrayBuffer);
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer);
      }
    };
  }
  this.text = function() {
    var rejected = consumed(this);
    if (rejected) {
      return rejected;
    }
    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob);
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
    } else if (this._bodyFormData) {
      throw new Error("could not read FormData body as text");
    } else {
      return Promise.resolve(this._bodyText);
    }
  };
  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode);
    };
  }
  this.json = function() {
    return this.text().then(JSON.parse);
  };
  return this;
}
function normalizeMethod(method) {
  var upcased = method.toUpperCase();
  return methods.indexOf(upcased) > -1 ? upcased : method;
}
function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  }
  options = options || {};
  var body = options.body;
  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError("Already read");
    }
    this.url = input.url;
    this.credentials = input.credentials;
    if (!options.headers) {
      this.headers = new Headers(input.headers);
    }
    this.method = input.method;
    this.mode = input.mode;
    this.signal = input.signal;
    if (!body && input._bodyInit != null) {
      body = input._bodyInit;
      input.bodyUsed = true;
    }
  } else {
    this.url = String(input);
  }
  this.credentials = options.credentials || this.credentials || "same-origin";
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers);
  }
  this.method = normalizeMethod(options.method || this.method || "GET");
  this.mode = options.mode || this.mode || null;
  this.signal = options.signal || this.signal;
  this.referrer = null;
  if ((this.method === "GET" || this.method === "HEAD") && body) {
    throw new TypeError("Body not allowed for GET or HEAD requests");
  }
  this._initBody(body);
  if (this.method === "GET" || this.method === "HEAD") {
    if (options.cache === "no-store" || options.cache === "no-cache") {
      var reParamSearch = /([?&])_=[^&]*/;
      if (reParamSearch.test(this.url)) {
        this.url = this.url.replace(reParamSearch, "$1_=" + new Date().getTime());
      } else {
        var reQueryString = /\?/;
        this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + new Date().getTime();
      }
    }
  }
}
function decode(body) {
  var form = new FormData();
  body.trim().split("&").forEach(function(bytes) {
    if (bytes) {
      var split = bytes.split("=");
      var name = split.shift().replace(/\+/g, " ");
      var value = split.join("=").replace(/\+/g, " ");
      form.append(decodeURIComponent(name), decodeURIComponent(value));
    }
  });
  return form;
}
function parseHeaders(rawHeaders) {
  var headers = new Headers();
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
  preProcessedHeaders.split("\r").map(function(header) {
    return header.indexOf("\n") === 0 ? header.substr(1, header.length) : header;
  }).forEach(function(line) {
    var parts = line.split(":");
    var key = parts.shift().trim();
    if (key) {
      var value = parts.join(":").trim();
      headers.append(key, value);
    }
  });
  return headers;
}
function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
  }
  if (!options) {
    options = {};
  }
  this.type = "default";
  this.status = options.status === void 0 ? 200 : options.status;
  this.ok = this.status >= 200 && this.status < 300;
  this.statusText = options.statusText === void 0 ? "" : "" + options.statusText;
  this.headers = new Headers(options.headers);
  this.url = options.url || "";
  this._initBody(bodyInit);
}
function fetch2(input, init) {
  return new Promise(function(resolve, reject) {
    var request2 = new Request(input, init);
    if (request2.signal && request2.signal.aborted) {
      return reject(new DOMException("Aborted", "AbortError"));
    }
    var xhr = new XMLHttpRequest();
    function abortXhr() {
      xhr.abort();
    }
    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || "")
      };
      options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
      var body = "response" in xhr ? xhr.response : xhr.responseText;
      setTimeout(function() {
        resolve(new Response(body, options));
      }, 0);
    };
    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError("Network request failed"));
      }, 0);
    };
    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError("Network request failed"));
      }, 0);
    };
    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException("Aborted", "AbortError"));
      }, 0);
    };
    function fixUrl(url) {
      try {
        return url === "" && global.location.href ? global.location.href : url;
      } catch (e) {
        return url;
      }
    }
    xhr.open(request2.method, fixUrl(request2.url), true);
    if (request2.credentials === "include") {
      xhr.withCredentials = true;
    } else if (request2.credentials === "omit") {
      xhr.withCredentials = false;
    }
    if ("responseType" in xhr) {
      if (support.blob) {
        xhr.responseType = "blob";
      } else if (support.arrayBuffer && request2.headers.get("Content-Type") && request2.headers.get("Content-Type").indexOf("application/octet-stream") !== -1) {
        xhr.responseType = "arraybuffer";
      }
    }
    if (init && typeof init.headers === "object" && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
      });
    } else {
      request2.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });
    }
    if (request2.signal) {
      request2.signal.addEventListener("abort", abortXhr);
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4) {
          request2.signal.removeEventListener("abort", abortXhr);
        }
      };
    }
    xhr.send(typeof request2._bodyInit === "undefined" ? null : request2._bodyInit);
  });
}
var global, support, viewClasses, isArrayBufferView, methods, redirectStatuses, DOMException;
var init_fetch = __esm({
  "../../node_modules/whatwg-fetch/fetch.js"() {
    global = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof global !== "undefined" && global;
    support = {
      searchParams: "URLSearchParams" in global,
      iterable: "Symbol" in global && "iterator" in Symbol,
      blob: "FileReader" in global && "Blob" in global && function() {
        try {
          new Blob();
          return true;
        } catch (e) {
          return false;
        }
      }(),
      formData: "FormData" in global,
      arrayBuffer: "ArrayBuffer" in global
    };
    if (support.arrayBuffer) {
      viewClasses = [
        "[object Int8Array]",
        "[object Uint8Array]",
        "[object Uint8ClampedArray]",
        "[object Int16Array]",
        "[object Uint16Array]",
        "[object Int32Array]",
        "[object Uint32Array]",
        "[object Float32Array]",
        "[object Float64Array]"
      ];
      isArrayBufferView = ArrayBuffer.isView || function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
      };
    }
    Headers.prototype.append = function(name, value) {
      name = normalizeName(name);
      value = normalizeValue(value);
      var oldValue = this.map[name];
      this.map[name] = oldValue ? oldValue + ", " + value : value;
    };
    Headers.prototype["delete"] = function(name) {
      delete this.map[normalizeName(name)];
    };
    Headers.prototype.get = function(name) {
      name = normalizeName(name);
      return this.has(name) ? this.map[name] : null;
    };
    Headers.prototype.has = function(name) {
      return this.map.hasOwnProperty(normalizeName(name));
    };
    Headers.prototype.set = function(name, value) {
      this.map[normalizeName(name)] = normalizeValue(value);
    };
    Headers.prototype.forEach = function(callback, thisArg) {
      for (var name in this.map) {
        if (this.map.hasOwnProperty(name)) {
          callback.call(thisArg, this.map[name], name, this);
        }
      }
    };
    Headers.prototype.keys = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push(name);
      });
      return iteratorFor(items);
    };
    Headers.prototype.values = function() {
      var items = [];
      this.forEach(function(value) {
        items.push(value);
      });
      return iteratorFor(items);
    };
    Headers.prototype.entries = function() {
      var items = [];
      this.forEach(function(value, name) {
        items.push([name, value]);
      });
      return iteratorFor(items);
    };
    if (support.iterable) {
      Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
    }
    methods = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
    Request.prototype.clone = function() {
      return new Request(this, { body: this._bodyInit });
    };
    Body.call(Request.prototype);
    Body.call(Response.prototype);
    Response.prototype.clone = function() {
      return new Response(this._bodyInit, {
        status: this.status,
        statusText: this.statusText,
        headers: new Headers(this.headers),
        url: this.url
      });
    };
    Response.error = function() {
      var response = new Response(null, { status: 0, statusText: "" });
      response.type = "error";
      return response;
    };
    redirectStatuses = [301, 302, 303, 307, 308];
    Response.redirect = function(url, status) {
      if (redirectStatuses.indexOf(status) === -1) {
        throw new RangeError("Invalid status code");
      }
      return new Response(null, { status, headers: { location: url } });
    };
    DOMException = global.DOMException;
    try {
      new DOMException();
    } catch (err) {
      DOMException = function(message, name) {
        this.message = message;
        this.name = name;
        var error = Error(message);
        this.stack = error.stack;
      };
      DOMException.prototype = Object.create(Error.prototype);
      DOMException.prototype.constructor = DOMException;
    }
    fetch2.polyfill = true;
    if (!global.fetch) {
      global.fetch = fetch2;
      global.Headers = Headers;
      global.Request = Request;
      global.Response = Response;
    }
  }
});

// ../../node_modules/next-axiom/dist/logger.js
var require_logger = __commonJS({
  "../../node_modules/next-axiom/dist/logger.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    var __createBinding = exports && exports.__createBinding || (Object.create ? function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      var desc = Object.getOwnPropertyDescriptor(m, k);
      if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m[k];
        } };
      }
      Object.defineProperty(o, k2, desc);
    } : function(o, m, k, k2) {
      if (k2 === void 0)
        k2 = k;
      o[k2] = m[k];
    });
    var __setModuleDefault = exports && exports.__setModuleDefault || (Object.create ? function(o, v) {
      Object.defineProperty(o, "default", { enumerable: true, value: v });
    } : function(o, v) {
      o["default"] = v;
    });
    var __importStar = exports && exports.__importStar || function(mod) {
      if (mod && mod.__esModule)
        return mod;
      var result = {};
      if (mod != null) {
        for (var k in mod)
          if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
            __createBinding(result, mod, k);
      }
      __setModuleDefault(result, mod);
      return result;
    };
    var __awaiter = exports && exports.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __generator = exports && exports.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1)
          throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f)
          throw new TypeError("Generator is already executing.");
        while (_)
          try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
              return t;
            if (y = 0, t)
              op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return { value: op[1], done: false };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2])
                  _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    var __spreadArray = exports && exports.__spreadArray || function(to, from, pack) {
      if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
          if (ar || !(i in from)) {
            if (!ar)
              ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
          }
        }
      return to.concat(ar || Array.prototype.slice.call(from));
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.prettyPrint = exports.log = exports.Logger = exports.LogLevel = void 0;
    var config_1 = __importStar(require_config());
    var shared_1 = require_shared();
    var url = config_1.default.getLogsEndpoint();
    var LOG_LEVEL = process.env.AXIOM_LOG_LEVEL || "debug";
    var LogLevel;
    (function(LogLevel2) {
      LogLevel2[LogLevel2["debug"] = 0] = "debug";
      LogLevel2[LogLevel2["info"] = 1] = "info";
      LogLevel2[LogLevel2["warn"] = 2] = "warn";
      LogLevel2[LogLevel2["error"] = 3] = "error";
      LogLevel2[LogLevel2["off"] = 100] = "off";
    })(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
    var Logger = function() {
      function Logger2(args, req, autoFlush, source, logLevel) {
        if (args === void 0) {
          args = {};
        }
        if (req === void 0) {
          req = null;
        }
        if (autoFlush === void 0) {
          autoFlush = true;
        }
        if (source === void 0) {
          source = "frontend";
        }
        var _this = this;
        this.args = args;
        this.req = req;
        this.autoFlush = autoFlush;
        this.source = source;
        this.logEvents = [];
        this.throttledSendLogs = (0, shared_1.throttle)(this.sendLogs, 1e3);
        this.children = [];
        this.debug = function(message, args2) {
          if (args2 === void 0) {
            args2 = {};
          }
          _this._log("debug", message, args2);
        };
        this.info = function(message, args2) {
          if (args2 === void 0) {
            args2 = {};
          }
          _this._log("info", message, args2);
        };
        this.warn = function(message, args2) {
          if (args2 === void 0) {
            args2 = {};
          }
          _this._log("warn", message, args2);
        };
        this.error = function(message, args2) {
          if (args2 === void 0) {
            args2 = {};
          }
          _this._log("error", message, args2);
        };
        this.with = function(args2) {
          var child = new Logger2(__assign(__assign({}, _this.args), args2), _this.req, _this.autoFlush, _this.source);
          _this.children.push(child);
          return child;
        };
        this.withRequest = function(req2) {
          return new Logger2(__assign({}, _this.args), req2, _this.autoFlush, _this.source);
        };
        this._log = function(level, message, args2) {
          if (args2 === void 0) {
            args2 = {};
          }
          if (LogLevel[level] < LogLevel[_this.logLevel]) {
            return;
          }
          var logEvent = { level, message, _time: new Date(Date.now()).toISOString(), fields: _this.args || {} };
          if (args2 instanceof Error) {
            logEvent.fields = __assign(__assign({}, logEvent.fields), { message: args2.message, stack: args2.stack, name: args2.name });
          } else if (typeof args2 === "object" && args2 !== null && Object.keys(args2).length > 0) {
            var parsedArgs = JSON.parse(JSON.stringify(args2, jsonFriendlyErrorReplacer));
            logEvent.fields = __assign(__assign({}, logEvent.fields), parsedArgs);
          } else if (args2 && args2.length) {
            logEvent.fields = __assign(__assign({}, logEvent.fields), { args: args2 });
          }
          config_1.default.injectPlatformMetadata(logEvent, _this.source);
          if (_this.req != null) {
            logEvent.request = _this.req;
            if (logEvent.platform) {
              logEvent.platform.route = _this.req.path;
            } else if (logEvent.vercel) {
              logEvent.vercel.route = _this.req.path;
            }
          }
          _this.logEvents.push(logEvent);
          if (_this.autoFlush) {
            _this.throttledSendLogs();
          }
        };
        this.attachResponseStatus = function(statusCode) {
          _this.logEvents = _this.logEvents.map(function(log2) {
            if (log2.request) {
              log2.request.statusCode = statusCode;
            }
            return log2;
          });
        };
        this.flush = function() {
          return __awaiter(_this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              switch (_a.label) {
                case 0:
                  return [4, Promise.all(__spreadArray([this.sendLogs()], this.children.map(function(c) {
                    return c.flush();
                  }), true))];
                case 1:
                  _a.sent();
                  return [2];
              }
            });
          });
        };
        this.logLevel = logLevel || LOG_LEVEL || "debug";
      }
      Logger2.prototype.sendLogs = function() {
        return __awaiter(this, void 0, void 0, function() {
          function sendFallback() {
            fetch(url, reqOptions).catch(console.error);
          }
          var method, keepalive, body, headers, reqOptions, fetch_1, e_1;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                if (!this.logEvents.length) {
                  return [2];
                }
                if (!config_1.default.isEnvVarsSet()) {
                  this.logEvents.forEach(function(ev) {
                    return prettyPrint(ev);
                  });
                  this.logEvents = [];
                  return [2];
                }
                method = "POST";
                keepalive = true;
                body = JSON.stringify(this.logEvents);
                this.logEvents = [];
                headers = {
                  "Content-Type": "application/json",
                  "User-Agent": "next-axiom/v" + config_1.Version
                };
                if (config_1.default.token) {
                  headers["Authorization"] = "Bearer ".concat(config_1.default.token);
                }
                reqOptions = { body, method, keepalive, headers };
                _a.label = 1;
              case 1:
                _a.trys.push([1, 5, , 6]);
                if (!(typeof fetch === "undefined"))
                  return [3, 3];
                return [4, (init_fetch(), __toCommonJS(fetch_exports))];
              case 2:
                fetch_1 = _a.sent();
                fetch_1(url, reqOptions).catch(console.error);
                return [3, 4];
              case 3:
                if (config_1.default.isBrowser && config_1.isVercel && navigator.sendBeacon) {
                  if (!navigator.sendBeacon(url, body)) {
                    sendFallback();
                  }
                } else {
                  sendFallback();
                }
                _a.label = 4;
              case 4:
                return [3, 6];
              case 5:
                e_1 = _a.sent();
                console.error("Failed to send logs to Axiom: ".concat(e_1));
                return [3, 6];
              case 6:
                return [2];
            }
          });
        });
      };
      return Logger2;
    }();
    exports.Logger = Logger;
    exports.log = new Logger();
    var levelColors = {
      info: {
        terminal: "32",
        browser: "lightgreen"
      },
      debug: {
        terminal: "36",
        browser: "lightblue"
      },
      warn: {
        terminal: "33",
        browser: "yellow"
      },
      error: {
        terminal: "31",
        browser: "red"
      }
    };
    function prettyPrint(ev) {
      var hasFields = Object.keys(ev.fields).length > 0;
      if (shared_1.isNoPrettyPrint) {
        var msg = "".concat(ev.level, " - ").concat(ev.message);
        if (hasFields) {
          msg += " " + JSON.stringify(ev.fields);
        }
        console.log(msg);
        return;
      }
      var msgString = "";
      var args = [ev.level, ev.message];
      if (config_1.default.isBrowser) {
        msgString = "%c%s - %s";
        args = __spreadArray(["color: ".concat(levelColors[ev.level].browser, ";")], args, true);
      } else {
        msgString = "\x1B[".concat(levelColors[ev.level].terminal, "m%s\x1B[0m - %s");
      }
      if (hasFields) {
        msgString += " %o";
        args.push(ev.fields);
      }
      if (ev.request) {
        msgString += " %o";
        args.push(ev.request);
      }
      console.log.apply(console, __spreadArray([msgString], args, true));
    }
    exports.prettyPrint = prettyPrint;
    function jsonFriendlyErrorReplacer(key, value) {
      if (value instanceof Error) {
        return __assign(__assign({}, value), {
          name: value.name,
          message: value.message,
          stack: value.stack
        });
      }
      return value;
    }
  }
});

// ../../node_modules/next-axiom/dist/withAxiom.js
var require_withAxiom = __commonJS({
  "../../node_modules/next-axiom/dist/withAxiom.js"(exports) {
    "use strict";
    var __assign = exports && exports.__assign || function() {
      __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s)
            if (Object.prototype.hasOwnProperty.call(s, p))
              t[p] = s[p];
        }
        return t;
      };
      return __assign.apply(this, arguments);
    };
    var __awaiter = exports && exports.__awaiter || function(thisArg, _arguments, P, generator) {
      function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
          resolve(value);
        });
      }
      return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
          try {
            step(generator.next(value));
          } catch (e) {
            reject(e);
          }
        }
        function rejected(value) {
          try {
            step(generator["throw"](value));
          } catch (e) {
            reject(e);
          }
        }
        function step(result) {
          result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
    };
    var __generator = exports && exports.__generator || function(thisArg, body) {
      var _ = { label: 0, sent: function() {
        if (t[0] & 1)
          throw t[1];
        return t[1];
      }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
      }), g;
      function verb(n) {
        return function(v) {
          return step([n, v]);
        };
      }
      function step(op) {
        if (f)
          throw new TypeError("Generator is already executing.");
        while (_)
          try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
              return t;
            if (y = 0, t)
              op = [op[0] & 2, t.value];
            switch (op[0]) {
              case 0:
              case 1:
                t = op;
                break;
              case 4:
                _.label++;
                return { value: op[1], done: false };
              case 5:
                _.label++;
                y = op[1];
                op = [0];
                continue;
              case 7:
                op = _.ops.pop();
                _.trys.pop();
                continue;
              default:
                if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                  _ = 0;
                  continue;
                }
                if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                  _.label = op[1];
                  break;
                }
                if (op[0] === 6 && _.label < t[1]) {
                  _.label = t[1];
                  t = op;
                  break;
                }
                if (t && _.label < t[2]) {
                  _.label = t[2];
                  _.ops.push(op);
                  break;
                }
                if (t[2])
                  _.ops.pop();
                _.trys.pop();
                continue;
            }
            op = body.call(thisArg, _);
          } catch (e) {
            op = [6, e];
            y = 0;
          } finally {
            f = t = 0;
          }
        if (op[0] & 5)
          throw op[1];
        return { value: op[0] ? op[1] : void 0, done: true };
      }
    };
    var __importDefault = exports && exports.__importDefault || function(mod) {
      return mod && mod.__esModule ? mod : { "default": mod };
    };
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.withAxiomGetServerSideProps = exports.withAxiom = exports.withAxiomNextEdgeFunction = exports.withAxiomNextServerSidePropsHandler = exports.withAxiomNextApiHandler = exports.withAxiomNextConfig = void 0;
    var logger_1 = require_logger();
    var shared_1 = require_shared();
    var config_1 = __importDefault(require_config());
    function withAxiomNextConfig(nextConfig) {
      var _this = this;
      return __assign(__assign({}, nextConfig), { rewrites: function() {
        return __awaiter(_this, void 0, void 0, function() {
          var rewrites, webVitalsEndpoint, logsEndpoint, log2, axiomRewrites;
          var _a;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                return [4, (_a = nextConfig.rewrites) === null || _a === void 0 ? void 0 : _a.call(nextConfig)];
              case 1:
                rewrites = _b.sent();
                webVitalsEndpoint = config_1.default.getIngestURL(shared_1.EndpointType.webVitals);
                logsEndpoint = config_1.default.getIngestURL(shared_1.EndpointType.logs);
                if (!webVitalsEndpoint && !logsEndpoint) {
                  log2 = new logger_1.Logger();
                  log2.warn("axiom: Envvars not detected. If this is production please see https://github.com/axiomhq/next-axiom for help");
                  log2.warn("axiom: Sending Web Vitals to /dev/null");
                  log2.warn("axiom: Sending logs to console");
                  return [2, rewrites || []];
                }
                axiomRewrites = [
                  {
                    source: "".concat(config_1.default.proxyPath, "/web-vitals"),
                    destination: webVitalsEndpoint,
                    basePath: false
                  },
                  {
                    source: "".concat(config_1.default.proxyPath, "/logs"),
                    destination: logsEndpoint,
                    basePath: false
                  }
                ];
                if (!rewrites) {
                  return [2, axiomRewrites];
                } else if (Array.isArray(rewrites)) {
                  return [2, rewrites.concat(axiomRewrites)];
                } else {
                  rewrites.afterFiles = (rewrites.afterFiles || []).concat(axiomRewrites);
                  return [2, rewrites];
                }
                return [2];
            }
          });
        });
      } });
    }
    exports.withAxiomNextConfig = withAxiomNextConfig;
    function interceptNextApiResponse(req, res) {
      var _this = this;
      var allPromises = [];
      var resSend = res.send;
      res.send = function(body) {
        allPromises.push(function() {
          return __awaiter(_this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              switch (_a.label) {
                case 0:
                  req.log.attachResponseStatus(res.statusCode);
                  return [4, req.log.flush()];
                case 1:
                  _a.sent();
                  resSend(body);
                  return [2];
              }
            });
          });
        }());
      };
      var resJson = res.json;
      res.json = function(json) {
        allPromises.push(function() {
          return __awaiter(_this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              switch (_a.label) {
                case 0:
                  req.log.attachResponseStatus(res.statusCode);
                  return [4, req.log.flush()];
                case 1:
                  _a.sent();
                  resJson(json);
                  return [2];
              }
            });
          });
        }());
      };
      var resEnd = res.end;
      res.end = function(cb) {
        allPromises.push(function() {
          return __awaiter(_this, void 0, void 0, function() {
            return __generator(this, function(_a) {
              switch (_a.label) {
                case 0:
                  req.log.attachResponseStatus(res.statusCode);
                  return [4, req.log.flush()];
                case 1:
                  _a.sent();
                  resEnd(cb);
                  return [2];
              }
            });
          });
        }());
        return res;
      };
      return [res, allPromises];
    }
    function withAxiomNextApiHandler(handler) {
      var _this = this;
      return function(req, res) {
        return __awaiter(_this, void 0, void 0, function() {
          var report, logger, axiomRequest, _a, wrappedRes, allPromises, error_1;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                report = config_1.default.generateRequestMeta(req);
                logger = new logger_1.Logger({}, report, false, "lambda");
                axiomRequest = req;
                axiomRequest.log = logger;
                _a = interceptNextApiResponse(axiomRequest, res), wrappedRes = _a[0], allPromises = _a[1];
                _b.label = 1;
              case 1:
                _b.trys.push([1, 5, , 8]);
                return [4, handler(axiomRequest, wrappedRes)];
              case 2:
                _b.sent();
                return [4, logger.flush()];
              case 3:
                _b.sent();
                return [4, Promise.all(allPromises)];
              case 4:
                _b.sent();
                return [3, 8];
              case 5:
                error_1 = _b.sent();
                logger.error("Error in API handler", { error: error_1 });
                logger.attachResponseStatus(500);
                return [4, logger.flush()];
              case 6:
                _b.sent();
                return [4, Promise.all(allPromises)];
              case 7:
                _b.sent();
                throw error_1;
              case 8:
                return [2];
            }
          });
        });
      };
    }
    exports.withAxiomNextApiHandler = withAxiomNextApiHandler;
    function withAxiomNextServerSidePropsHandler(handler) {
      var _this = this;
      return function(context) {
        return __awaiter(_this, void 0, void 0, function() {
          var report, logger, axiomContext, result, error_2;
          return __generator(this, function(_a) {
            switch (_a.label) {
              case 0:
                report = config_1.default.generateRequestMeta(context.req);
                logger = new logger_1.Logger({}, report, false, "lambda");
                axiomContext = context;
                axiomContext.log = logger;
                _a.label = 1;
              case 1:
                _a.trys.push([1, 4, , 6]);
                return [4, handler(axiomContext)];
              case 2:
                result = _a.sent();
                return [4, logger.flush()];
              case 3:
                _a.sent();
                return [2, result];
              case 4:
                error_2 = _a.sent();
                logger.error("Error in getServerSideProps handler", { error: error_2 });
                logger.attachResponseStatus(500);
                return [4, logger.flush()];
              case 5:
                _a.sent();
                throw error_2;
              case 6:
                return [2];
            }
          });
        });
      };
    }
    exports.withAxiomNextServerSidePropsHandler = withAxiomNextServerSidePropsHandler;
    function withAxiomNextEdgeFunction(handler) {
      var _this = this;
      return function(req, ev) {
        return __awaiter(_this, void 0, void 0, function() {
          var report, logger, axiomRequest, res, error_3;
          var _a;
          return __generator(this, function(_b) {
            switch (_b.label) {
              case 0:
                report = {
                  startTime: new Date().getTime(),
                  ip: req.ip,
                  region: (_a = req.geo) === null || _a === void 0 ? void 0 : _a.region,
                  host: req.nextUrl.host,
                  method: req.method,
                  path: req.nextUrl.pathname,
                  scheme: req.nextUrl.protocol.replace(":", ""),
                  userAgent: req.headers.get("user-agent")
                };
                logger = new logger_1.Logger({}, report, false, "edge");
                axiomRequest = req;
                axiomRequest.log = logger;
                _b.label = 1;
              case 1:
                _b.trys.push([1, 3, , 4]);
                return [4, handler(axiomRequest, ev)];
              case 2:
                res = _b.sent();
                if (res) {
                  logger.attachResponseStatus(res.status);
                }
                ev.waitUntil(logger.flush());
                logEdgeReport(report);
                return [2, res];
              case 3:
                error_3 = _b.sent();
                logger.error("Error in edge function", { error: error_3 });
                logger.attachResponseStatus(500);
                ev.waitUntil(logger.flush());
                logEdgeReport(report);
                throw error_3;
              case 4:
                return [2];
            }
          });
        });
      };
    }
    exports.withAxiomNextEdgeFunction = withAxiomNextEdgeFunction;
    function logEdgeReport(report) {
      if (config_1.default.shoudSendEdgeReport) {
        console.log("AXIOM_EDGE_REPORT::".concat(JSON.stringify(report)));
      }
    }
    function isNextConfig(param) {
      return typeof param == "object";
    }
    function isApiHandler(param) {
      var isFunction = typeof param == "function";
      return isFunction && typeof globalThis.EdgeRuntime === "undefined" && process.env.NEXT_RUNTIME != "edge";
    }
    function withAxiom(param) {
      if (isNextConfig(param)) {
        return withAxiomNextConfig(param);
      } else if (isApiHandler(param)) {
        return withAxiomNextApiHandler(param);
      } else {
        return withAxiomNextEdgeFunction(param);
      }
    }
    exports.withAxiom = withAxiom;
    exports.withAxiomGetServerSideProps = withAxiomNextServerSidePropsHandler;
  }
});

// ../../node_modules/next-axiom/dist/index.js
var require_dist = __commonJS({
  "../../node_modules/next-axiom/dist/index.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.withAxiomGetServerSideProps = exports.withAxiom = exports.Logger = exports.log = exports.reportWebVitalsWithPath = exports.reportWebVitals = void 0;
    var webVitals_1 = require_webVitals();
    Object.defineProperty(exports, "reportWebVitals", { enumerable: true, get: function() {
      return webVitals_1.reportWebVitals;
    } });
    Object.defineProperty(exports, "reportWebVitalsWithPath", { enumerable: true, get: function() {
      return webVitals_1.reportWebVitalsWithPath;
    } });
    var logger_1 = require_logger();
    Object.defineProperty(exports, "log", { enumerable: true, get: function() {
      return logger_1.log;
    } });
    Object.defineProperty(exports, "Logger", { enumerable: true, get: function() {
      return logger_1.Logger;
    } });
    var withAxiom_1 = require_withAxiom();
    Object.defineProperty(exports, "withAxiom", { enumerable: true, get: function() {
      return withAxiom_1.withAxiom;
    } });
    Object.defineProperty(exports, "withAxiomGetServerSideProps", { enumerable: true, get: function() {
      return withAxiom_1.withAxiomGetServerSideProps;
    } });
  }
});

// src/enums/Http.ts
var HttpMethods = /* @__PURE__ */ ((HttpMethods2) => {
  HttpMethods2["Get"] = "GET";
  HttpMethods2["Post"] = "POST";
  HttpMethods2["Put"] = "PUT";
  HttpMethods2["Patch"] = "PATCH";
  HttpMethods2["Delete"] = "DELETE";
  return HttpMethods2;
})(HttpMethods || {});
var HttpStatus = /* @__PURE__ */ ((HttpStatus2) => {
  HttpStatus2[HttpStatus2["None"] = 0] = "None";
  HttpStatus2[HttpStatus2["Ok"] = 200] = "Ok";
  HttpStatus2[HttpStatus2["Created"] = 201] = "Created";
  HttpStatus2[HttpStatus2["Accepted"] = 202] = "Accepted";
  HttpStatus2[HttpStatus2["NonAuthoritativeInformation"] = 203] = "NonAuthoritativeInformation";
  HttpStatus2[HttpStatus2["NoContent"] = 204] = "NoContent";
  HttpStatus2[HttpStatus2["ResetContent"] = 205] = "ResetContent";
  HttpStatus2[HttpStatus2["PartialContent"] = 206] = "PartialContent";
  HttpStatus2[HttpStatus2["MultiStatus"] = 207] = "MultiStatus";
  HttpStatus2[HttpStatus2["AlreadyReported"] = 208] = "AlreadyReported";
  HttpStatus2[HttpStatus2["IMUsed"] = 209] = "IMUsed";
  HttpStatus2[HttpStatus2["BadRequest"] = 400] = "BadRequest";
  HttpStatus2[HttpStatus2["Unauthorized"] = 401] = "Unauthorized";
  HttpStatus2[HttpStatus2["PaymentRequired"] = 402] = "PaymentRequired";
  HttpStatus2[HttpStatus2["Forbidden"] = 403] = "Forbidden";
  HttpStatus2[HttpStatus2["NotFound"] = 404] = "NotFound";
  HttpStatus2[HttpStatus2["MethodNotAllowed"] = 405] = "MethodNotAllowed";
  HttpStatus2[HttpStatus2["NotAcceptable"] = 406] = "NotAcceptable";
  HttpStatus2[HttpStatus2["ProxyAuthenticationRequired"] = 407] = "ProxyAuthenticationRequired";
  HttpStatus2[HttpStatus2["RequestTimeout"] = 408] = "RequestTimeout";
  HttpStatus2[HttpStatus2["Conflict"] = 409] = "Conflict";
  HttpStatus2[HttpStatus2["Gone"] = 410] = "Gone";
  HttpStatus2[HttpStatus2["LengthRequired"] = 411] = "LengthRequired";
  HttpStatus2[HttpStatus2["PreconditionFailed"] = 412] = "PreconditionFailed";
  HttpStatus2[HttpStatus2["PayloadTooLarge"] = 413] = "PayloadTooLarge";
  HttpStatus2[HttpStatus2["RequestUriTooLong"] = 414] = "RequestUriTooLong";
  HttpStatus2[HttpStatus2["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
  HttpStatus2[HttpStatus2["RequestedRangeNotSatisfiable"] = 416] = "RequestedRangeNotSatisfiable";
  HttpStatus2[HttpStatus2["ExpectationFailed"] = 417] = "ExpectationFailed";
  HttpStatus2[HttpStatus2["Teapot"] = 418] = "Teapot";
  HttpStatus2[HttpStatus2["InternalServerError"] = 500] = "InternalServerError";
  HttpStatus2[HttpStatus2["NotImplemented"] = 501] = "NotImplemented";
  HttpStatus2[HttpStatus2["BadGateway"] = 502] = "BadGateway";
  HttpStatus2[HttpStatus2["ServiceUnavailable"] = 503] = "ServiceUnavailable";
  HttpStatus2[HttpStatus2["GatewayTimeout"] = 504] = "GatewayTimeout";
  HttpStatus2[HttpStatus2["HttpVersionNotSupported"] = 505] = "HttpVersionNotSupported";
  HttpStatus2[HttpStatus2["VariantAlsoNegotiates"] = 506] = "VariantAlsoNegotiates";
  HttpStatus2[HttpStatus2["InsufficientStorage"] = 507] = "InsufficientStorage";
  HttpStatus2[HttpStatus2["LoopDetected"] = 508] = "LoopDetected";
  HttpStatus2[HttpStatus2["NotExtended"] = 510] = "NotExtended";
  HttpStatus2[HttpStatus2["NetworkAuthenticationRequired"] = 511] = "NetworkAuthenticationRequired";
  HttpStatus2[HttpStatus2["NetworkConnectionTimeoutError"] = 599] = "NetworkConnectionTimeoutError";
  return HttpStatus2;
})(HttpStatus || {});

// src/GraphQLApi/GraphQLApi.ts
import { request } from "graphql-request";
var GraphQLApi = class {
  constructor(baseUrl, headers) {
    this.baseUrl = baseUrl;
    if (headers)
      this.headers = headers;
  }
  async ExecuteRequest(query, variables) {
    try {
      const response = await request({
        url: this.baseUrl,
        document: query,
        variables,
        requestHeaders: this.headers
      });
      return this.handleSuccess(response);
    } catch (err) {
      return this.handleError(err);
    }
  }
  handleSuccess(response) {
    const _response = {
      error: false,
      status: 200 /* Ok */,
      body: response
    };
    return _response;
  }
  handleError(error) {
    const _response = {
      error: true,
      errorMessage: error,
      status: 0 /* None */,
      body: null
    };
    return _response;
  }
};

// src/Log/Log.ts
var import_traverse = __toESM(require_traverse());
import axios from "axios";

// src/Log/maskRules.ts
var maskRules = /* @__PURE__ */ new Map([
  [
    "description",
    (value) => {
      if (!!value)
        return value.slice(0, 10);
      return value;
    }
  ],
  [
    "paymentInfo",
    (value) => {
      if (!!value) {
        return value?.map?.((item) => {
          return item?.replace?.(/^[\d-\s]+(?=\d{4})/, "************");
        });
      }
      return value;
    }
  ],
  ["cardnumber", () => "\u2022\u2022\u2022\u2022"],
  ["cvv", () => "\u2022\u2022\u2022"],
  ["expirymonth", () => "\u2022\u2022"],
  ["expiryyear", () => "\u2022\u2022"],
  ["firstname", (value) => maskString(value, 3)],
  ["lastname", (value) => maskString(value, 3)],
  ["firstName", (value) => maskString(value, 3)],
  ["lastName", (value) => maskString(value, 3)],
  ["phone", (value) => maskString(value, 3)],
  [
    "email",
    (value) => {
      const [left, right] = value.split("@");
      return `${maskString(left, 3)}@${right}`;
    }
  ]
]);
var maskString = (value, length) => {
  return `${value.slice(0, length)}${value.slice(length, value.length).replace(/./gi, "\u2022")}`;
};

// src/Log/Log.ts
var import_next_axiom = __toESM(require_dist());
var LogObject = class {
  constructor(init) {
    this.data = {};
    Object.assign(this, init);
  }
};
var Log = class {
  Info(message) {
    this.parse("info", message);
  }
  Warning(message) {
    this.parse("warning", message);
  }
  Error(message, callstack) {
    this.parse("error", message, callstack);
  }
  parse(type, message, callstack) {
    let method;
    if (type === "info")
      method = import_next_axiom.log.info;
    else if (type === "warning")
      method = import_next_axiom.log.warn;
    else
      method = import_next_axiom.log.error;
    try {
      if (typeof message !== "string") {
        if (message.data.request?.url?.includes("/vercel"))
          return;
        method("log", this.mask({ ...message }));
        const _message = `[${message.source}][${message.flowId}] ${JSON.stringify(message.data)}`;
        this.postMessage(type, _message, callstack);
      }
    } catch (err) {
      console.error(`Error on parsing log`, { err });
    }
  }
  async postMessage(type, message, callstack) {
    if (message.includes("/order/api/vercel"))
      return;
    try {
      await axios({
        baseURL: `/order/api`,
        url: "/log",
        method: "POST" /* Post */,
        data: { type, message: this.ToString(message), callstack }
      });
    } catch (err) {
      console.error(`Error on posting log`, { err });
    }
  }
  ToString(obj) {
    return obj;
  }
  mask(obj) {
    try {
      const masked = (0, import_traverse.default)(obj).map(function(val) {
        if (!val)
          return val;
        const mask = maskRules.get(this.key);
        if (mask)
          return mask(val);
        return val;
      });
      return masked;
    } catch (err) {
      return `Error on maskRules: ${err}`;
    }
  }
};
var instance = new Log();
var LogFunction = async (req, res) => {
  let status = 204 /* NoContent */;
  if (req.method === "POST" /* Post */) {
    const type = req.body.type;
    const message = JSON.stringify(req.body.message, null, 4);
    console.info(message);
    const callstack = req.body.callstack;
    if (!!callstack) {
      console.info(callstack);
    }
    if (type === "info")
      status = 204 /* NoContent */;
    else if (type === "warning")
      status = 400 /* BadRequest */;
    else
      status = 500 /* InternalServerError */;
  }
  res.status(status).send("");
};

// src/RestApi/RestApi.ts
import axios2 from "axios";
import { UtilsUuid, UtilsIsObjectEmpty } from "@maverick/utils";
var RestRequest = class {
  constructor(init) {
    Object.assign(this, init);
  }
};
var RestApi = class {
  constructor(baseUrl, headers, responseMiddleware) {
    this.baseUrl = baseUrl;
    this.responseMiddleware = responseMiddleware;
    if (headers)
      this.headers = headers;
  }
  async ExecuteRequest(request2) {
    let headers = this.headers ?? {};
    if (!!request2.auth)
      headers.authorization = request2.auth;
    if (!!request2.headers)
      headers = { ...headers, ...request2.headers };
    const _request = {
      baseURL: this.baseUrl,
      url: request2.endpoint,
      method: request2.method,
      headers,
      data: request2.body,
      responseType: request2.responseType ?? "json"
    };
    const log2 = new LogObject({ source: "RestApi", flowId: getFlowId() });
    log2.data.request = sanitizeRequest(_request);
    let responseHandled;
    try {
      const response = await axios2(_request);
      responseHandled = this.handleSuccess(response);
      log2.data.response = sanitizeResponse(responseHandled);
      instance.Info(log2);
    } catch (err) {
      responseHandled = this.handleError(err);
      log2.data.response = responseHandled;
      responseHandled.errorClient ? instance.Warning(log2) : instance.Error(log2);
    }
    return responseHandled;
  }
  handleSuccess(response) {
    const { status, data } = response;
    const _response = {
      error: false,
      errorClient: false,
      errorServer: false,
      errorNetwork: false,
      status,
      body: data
    };
    return this.responseMiddleware ? this.responseMiddleware(_response) : _response;
  }
  handleError(error) {
    const _response = { error: true, status: 0 /* None */, body: null };
    if (error && error.response) {
      const { status, data } = error.response;
      _response.errorClient = status >= 400 && status <= 499;
      _response.errorServer = status >= 500;
      _response.status = status;
      _response.body = data;
    } else {
      _response.errorNetwork = true;
    }
    return this.responseMiddleware ? this.responseMiddleware(_response) : _response;
  }
};
var getFlowId = () => {
  if (typeof window === "undefined")
    return "server-side";
  if (!("localStorage" in window))
    return "";
  let flowId = window.localStorage.getItem("flow-id");
  if (!flowId) {
    flowId = UtilsUuid();
    window.localStorage.setItem("flow-id", flowId);
  }
  return flowId;
};
var sanitizeRequest = (request2) => {
  const _request = structuredClone(request2);
  const baseUrl = request2.baseURL?.replace("/order/api", "");
  _request.url = `${request2.method} ${baseUrl}${_request.url}`;
  delete _request.baseURL;
  delete _request.method;
  delete _request.responseType;
  if (UtilsIsObjectEmpty(_request.headers))
    delete _request.headers;
  return _request;
};
var sanitizeResponse = (response) => {
  const _response = structuredClone(response);
  _response.error = void 0;
  _response.errorClient = void 0;
  _response.errorServer = void 0;
  _response.errorNetwork = void 0;
  _response.body = `(length: ${JSON.stringify(_response.body).length})`;
  return _response;
};
export {
  GraphQLApi,
  HttpMethods,
  HttpStatus,
  instance as Log,
  LogFunction,
  LogObject,
  RestApi,
  RestRequest,
  getFlowId
};
